import React from "react";
import { Outlet } from "react-router-dom";
import { Topbar } from "../components/layout/Topbar";

export const AppLayout = () => (
  <div className="min-h-screen w-full flex flex-col bg-slate-50 dark:bg-slate-900 transition-colors">
    <Topbar />
    <main className="container mx-auto max-w-7xl px-4 py-6">
      <Outlet />
    </main>
  </div>
);
